export const CMSActionTypes = {
  CLEAR_CMS: "CLEAR_CMS",
  IS_FETCHING: "CMS_IS_FETCHING",
  NOT_FETCHING: "CMS_NOT_FETCHING",
  UPDATE_LOGO: "UPDATE_LOGO"
};
